// Global scroll-reveal + page-transition animation.
// Non-invasive: adds classes to existing nodes, never changes layout/content.
const REDUCED =
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const SELECTORS = [
  '[class*="card"]',
  '[class*="Card"]',
  '[class*="item"]',
  "section",
  "article",
  "h1, h2, h3",
  '[class*="head"]',
];

let observer;

function ensureObserver() {
  if (observer || REDUCED) return;
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal-in");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: "0px 0px -8% 0px" }
  );
}

export function runReveal() {
  if (REDUCED) return;
  ensureObserver();
  const seen = new Set();
  SELECTORS.forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => {
      if (seen.has(el) || el.dataset.reveal) return;
      // skip header/footer chrome and tiny inline nodes
      if (el.closest("header") || el.closest("footer")) return;
      if (el.offsetHeight < 8) return;
      seen.add(el);
      el.dataset.reveal = "1";
      el.classList.add("reveal-init");
      observer.observe(el);
    });
  });
}

export function initReveal() {
  if (REDUCED) return;
  // run on load + on every DOM mutation (route changes, lazy content)
  const schedule = (() => {
    let raf = 0;
    return () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => runReveal());
    };
  })();
  window.addEventListener("load", schedule);
  const mo = new MutationObserver(schedule);
  mo.observe(document.body, { childList: true, subtree: true });
  schedule();
}
